<template lang="html">
  <div v-if="rotation.length" class="rotation" ref="rotation" :style="selfStyle">
    <van-swipe :autoplay="3000" loop :style="{ background: rotation.length ? '' : 'rgba(245,245,245,1)' }">
            <van-swipe-item v-for="item in rotation" :key="item.id">
                <div class="rotation-item">
                <img v-lazy="`${item.imageUrl}?x-oss-process=image/resize,fill,w_1080,h_360`" alt="" @click="goLink(item.link)">
                </div>
            </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { get } from '../utils/request'
import { Swipe, SwipeItem } from 'vant'
import dd from 'DD'
import { previewImage } from '../utils/ddUser'
export default {
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem
  },
  props: [
    'selfStyle'
  ],
  data () {
    return {
      rotation: []
    }
  },
  activated () {
    this.getPermission()
  },
  mounted () {
  },
  methods: {
    goLink (link) {
      // if (dd.env.platform !== 'notInDingTalk') {
      //   if (url) {
      //     previewImage([url], 0)
      //     // return
      //   }
      // }
      if (link === '') return
      const imgRegex = /png|jpg|svg|gif|jpeg/
      const result = link.match(imgRegex)
      if (result && result.length > 0) {
        if (dd.env.platform !== 'notInDingTalk') {
          if (link) {
            previewImage([link], 0)
          }
        } else {
          this.$router.push({
            path: `/noValidation/img/?url=${link}`
          })
        }
      } else {
        window.location = link
      }
    },
    async getPermission () {
      try {
        const data = await this.$API.getESGpermission()
        if (data.code === 200) {
          this.has_esg_entry = data.data.has_esg_entry
          this.getBanner()
        }
      } catch (error) {

      }
    },
    getBanner () {
      const promise = get({
        url: '/banner/banner'
      })
      promise.then(res => {
        const { status, data: { detail } } = res
        if (Object.is(status, 200)) {
          // detail[0].endTime = '2020年05月12日 星期二 20:45'
          // detail[1].endTime = '2020年05月12日 星期二 21:00'
          // detail[2].endTime = '2020年05月12日 星期二 16:00'
          var arr = []
          detail.map(item => {
            if (this.has_esg_entry) {
              arr.push(item)
            } else {
              if (item.name.toLowerCase().indexOf('esg') === -1) {
                arr.push(item)
              }
            }
          })
          this.rotation = arr
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.van-swipe {
  height: calc(91.47vw / 3);
}
::-webkit-scrollbar {
  display: none;
}
.rotation {
  width: 100%;
  background: rgba(216, 216, 216, 1);
  border-radius: 8px;
  box-sizing: border-box;
  .rotation-item {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
}
</style>
